const HANDLER_CSS_SELECTOR = '.ec-js-comparison-scroll-handler';

$(document).ready(function () {
    $(HANDLER_CSS_SELECTOR).on('scroll', function (event) {
        let left = $(event.target).children().offset().left - $(event.target).offset().left;

        $(this).siblings(HANDLER_CSS_SELECTOR).scrollLeft(-left);
    });
});